import { LAYER_TYPE, } from '@tmapy/config';
import { ADD_LAYERS, SET_LAYER_VISIBILITY } from '@tmapy/mapcore';
import { getInitialState } from './initialState';
import { LEGEND_SET_STATE, LEGEND_UPDATE_STATE } from '../constants';
export const legend = (state = getInitialState(), action) => {
    switch (action.type) {
        case LEGEND_SET_STATE: {
            return action.payload;
        }
        case LEGEND_UPDATE_STATE: {
            const { layerId, legendItems } = { ...action.payload };
            const updatedLegend = state.map((item) => {
                if (item.layerId === layerId) {
                    return { ...item, items: legendItems };
                }
                return item;
            });
            return updatedLegend;
        }
        case ADD_LAYERS: {
            const legendState = [...state];
            action.payload.forEach((layer) => legendState.push({ layerId: layer.id, type: layer.type, label: layer.label }));
            return legendState;
        }
        case SET_LAYER_VISIBILITY: {
            // promazani stavu WMS legendy pokud je zneviditelnena
            const updatedLegend = state.map((item) => {
                if (item.type === LAYER_TYPE.IMAGE_WMS &&
                    action.payload[item.layerId] === false &&
                    item.items?.length) {
                    // čištění mezipaměti - tuto akci nelze provádět v komponentě WMSLayerLegend
                    URL.revokeObjectURL(item.items?.[0]?.imgUrl);
                    return { ...item, items: [] };
                }
                return item;
            });
            return updatedLegend;
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map